import * as React from 'react';
import { MessageDescriptor, useIntl } from 'react-intl';

import { ModalContext, TooltipModel } from '@notino/react-styleguide';

import { PortalTooltip } from '@components/PortalTooltip';
import { useNewPdDesignEnabled } from '@containers/ProductDetailContainer/ProductDetail/hooks/useNewPdDesignEnabled';

import { GiftImage } from '../GiftImage/GiftImage';
import { GiftImageThumb } from '../GiftImage/GiftImageThumb';
import { GiftImageBlockWrapper } from '../GiftImage/styled';

import { Description, TooltipWrapper, GiftBaseItemWrapper } from './styled';

interface GiftBaseItemProps {
  imageUrl: string;
  descriptionText: string;
  imageMessage: MessageDescriptor;
}

export const GiftBaseItem: React.FC<GiftBaseItemProps> = ({
  descriptionText,
  imageUrl,
  imageMessage,
}) => {
  const { formatMessage } = useIntl();
  const { toggleModal } = ModalContext.useModalContext();
  const newPdDesignEnabled = useNewPdDesignEnabled();

  const giftImage = React.useMemo(
    () => (
      <GiftImage
        formattedImageMessage={formatMessage(imageMessage)}
        imageUrl={imageUrl}
      />
    ),
    [imageUrl, formatMessage, imageMessage]
  );

  const openModal = React.useCallback(() => {
    toggleModal(giftImage);
  }, [giftImage, toggleModal]);

  return (
    <GiftBaseItemWrapper data-testid="gift-base-item">
      <TooltipWrapper>
        <PortalTooltip
          content={<PortalTooltip.Content>{giftImage}</PortalTooltip.Content>}
          position={TooltipModel.Position.topLeft}
          disabled={!imageUrl}
        >
          <GiftImageThumb
            sourceKey="thumb"
            imageUrl={imageUrl}
            formattedImageMessage={formatMessage(imageMessage)}
            onClick={openModal}
          />
        </PortalTooltip>
      </TooltipWrapper>

      <GiftImageBlockWrapper>
        <GiftImageThumb
          sourceKey="list_2k"
          imageUrl={imageUrl}
          formattedImageMessage={formatMessage(imageMessage)}
          onClick={openModal}
        />
      </GiftImageBlockWrapper>

      <Description
        newDesign={newPdDesignEnabled}
        dangerouslySetInnerHTML={{ __html: descriptionText }}
      />
    </GiftBaseItemWrapper>
  );
};
